import React, { useState, memo } from "react";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import BackToTop from "@/components/backToTop";
import Link from "next/link";
import { getFormattedDate } from "@/utils/helper";
import { useContentfulTranslations } from "@/utils/contentfulTranslations";

const ITEMS_PER_PAGE = 20;

const PressRelease = ({
  pageHeading = "",
  pageSections = { pressReleases: [] },
}) => {
  const pressReleases = pageSections.pressReleases || [];
  const router = useRouter();
  const { locale = "" } = router;
  const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);

  const loadMore = () => {
    setVisibleCount(prev => prev + ITEMS_PER_PAGE);
  };
  const { PDP_LABELS } = useContentfulTranslations();

  return (
    <>
      <section className="px-4 lg:px-0">
        <div className="grid grid-cols-1 w-full mx-auto max-w-screen-lg">
          {/* HEADING */}
          <div className="text-center py-[40px]">
            <h1 className="text-[43px] md:text-[60px] text-[#232323] font-[400] mb-4">
              {pageHeading}
            </h1>
            <div className="border-b border-[#000] w-full mx-auto"></div>
          </div>

          {/* LIST */}
          <div>
            {pressReleases
              .slice(0, visibleCount)
              .map(({ fields, sys }, index) => (
                <div
                  key={sys?.id || index}
                  className="py-6 border-b border-[#d6d6d6] font-[HelveticaLight,Helvetica,sans-serif] leading-[1.5333333333em] font-normal"
                >
                  {/* DATE */}
                  {fields?.date && (
                    <p className="text-[15px] leading-[23px] font-[400]  text-[#232323] font-[Helvetica-Light,_Helvetica,_sans-serif]">
                      {getFormattedDate(locale, fields.date)}
                    </p>
                  )}

                  {/* TITLE */}
                  <Link
                    href={fields?.slug || "#"}
                    className="text-[15px] text-[#337ab7] no-underline hover:!no-underline cursor-pointer font-[Helvetica-Light,_Helvetica,_sans-serif] leading-[1.5333333333em] font-normal"
                  >
                    {fields.title}
                  </Link>
                </div>
              ))}
          </div>

          {/* LOAD MORE BUTTON */}
          {visibleCount < pressReleases.length && (
            <div className="flex justify-center py-12">
              <button
                onClick={loadMore}
                className="max-w-[320px] w-[320px] h-[40px] bg-[#dbdbdb] text-[#000] text-[13px] font-[600] uppercase hover:bg-[#cfcfcf] transition cursor-pointer font-[helvitaBold,_Helvetica,_sans-serif] rounded-[4px]"
              >
                {PDP_LABELS?.[locale]?.loadMore || "Load More"}
              </button>
            </div>
          )}
        </div>
      </section>

      <BackToTop topHeight={0} localeProp={locale} />
    </>
  );
};

PressRelease.propTypes = {
  pageHeading: PropTypes.string,
  pageSections: PropTypes.shape({
    pressReleases: PropTypes.array,
  }),
};

export default memo(PressRelease);
